import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { ImageFallbackDirective } from '../../directives/image-fallback.directive';

@Component({
  selector: 'app-round-image',
  templateUrl: './round-image.component.html',
  styleUrls: ['./round-image.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, NgClass, ImageFallbackDirective],
})
export class RoundImageComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() description?: string;
  @Input() src?: string | null;
  @Input() size: '60' | '80' | '120' = '80';
  @Input() disabled = false;
  @Input() rounded = true;

  defaultSrc = 'assets/defaults/Profil.png';
}
